// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { BoundMaterialLeadTimeConfigFields_MaterialLeadTimeConfigFragmentDoc } from '../components/BoundMaterialLeadTimeConfigFields.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type AdminItemsDrawerQueryVariables = Types.Exact<{
  itemId: Types.Scalars['ID']['input'];
}>;


export type AdminItemsDrawerQuery = { __typename?: 'Query', items: Array<{ __typename?: 'Item', id: string, materialCodePrefix?: string | null | undefined, materialNameFormat?: string | null | undefined, isMaterialModifier: boolean, materialAttributeDimensions: Array<{ __typename?: 'MaterialAttributeDimension', id: string, name: string, isAdminManaged: boolean, useInTakeoff: boolean, useInVisualModePdf: boolean, showInFinishSchedule: boolean, sortOrder: number, type: { __typename?: 'MaterialAttributeDimensionTypeDetail', code: Types.MaterialAttributeDimensionType, name: string }, unitOfMeasure?: { __typename?: 'UnitOfMeasure', id: string } | null | undefined, values: Array<{ __typename?: 'MaterialAttributeValue', id: string, code?: string | null | undefined, textValue: string }> }>, canBecomeMaterialModifier: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, materialLeadTimeConfig?: { __typename?: 'MaterialLeadTimeConfig', id: string, minLeadTimeInDays: number, maxLeadTimeInDays: number, expectedLeadTimeInDays: number, reasonNote?: string | null | undefined, variants: Array<{ __typename?: 'MaterialLeadTimeConfigVariant', id: string, minLeadTimeInDays?: number | null | undefined, maxLeadTimeInDays?: number | null | undefined, expectedLeadTimeInDays?: number | null | undefined, reasonNote?: string | null | undefined, market?: { __typename?: 'Market', id: string, name: string } | null | undefined }> } | null | undefined }> };

export type SaveItemDimensionsMutationVariables = Types.Exact<{
  input: Types.SaveItemsInput;
}>;


export type SaveItemDimensionsMutation = { __typename?: 'Mutation', saveItems: Array<{ __typename?: 'Item', id: string, materialAttributeDimensions: Array<{ __typename?: 'MaterialAttributeDimension', id: string, name: string, isAdminManaged: boolean, useInTakeoff: boolean, useInVisualModePdf: boolean, showInFinishSchedule: boolean, sortOrder: number, type: { __typename?: 'MaterialAttributeDimensionTypeDetail', code: Types.MaterialAttributeDimensionType, name: string }, unitOfMeasure?: { __typename?: 'UnitOfMeasure', id: string } | null | undefined, values: Array<{ __typename?: 'MaterialAttributeValue', id: string, code?: string | null | undefined, textValue: string }> }> }> };

export type AdminItemsDrawer_MaterialAttributeDimensionFragment = { __typename?: 'MaterialAttributeDimension', id: string, name: string, isAdminManaged: boolean, useInTakeoff: boolean, useInVisualModePdf: boolean, showInFinishSchedule: boolean, sortOrder: number, type: { __typename?: 'MaterialAttributeDimensionTypeDetail', code: Types.MaterialAttributeDimensionType, name: string }, unitOfMeasure?: { __typename?: 'UnitOfMeasure', id: string } | null | undefined, values: Array<{ __typename?: 'MaterialAttributeValue', id: string, code?: string | null | undefined, textValue: string }> };

export type AdminItemsDrawer_MaterialAttributeValueFragment = { __typename?: 'MaterialAttributeValue', id: string, code?: string | null | undefined, textValue: string };

export const AdminItemsDrawer_MaterialAttributeValueFragmentDoc = gql`
    fragment AdminItemsDrawer_MaterialAttributeValue on MaterialAttributeValue {
  id
  code
  textValue
}
    `;
export const AdminItemsDrawer_MaterialAttributeDimensionFragmentDoc = gql`
    fragment AdminItemsDrawer_MaterialAttributeDimension on MaterialAttributeDimension {
  id
  name
  type {
    code
    name
  }
  isAdminManaged
  useInTakeoff
  useInVisualModePdf
  showInFinishSchedule
  unitOfMeasure {
    id
  }
  values {
    ...AdminItemsDrawer_MaterialAttributeValue
  }
  sortOrder
}
    ${AdminItemsDrawer_MaterialAttributeValueFragmentDoc}`;
export const AdminItemsDrawerDocument = gql`
    query AdminItemsDrawer($itemId: ID!) {
  items(filter: {id: [$itemId], version: [1, 2]}) {
    id
    materialCodePrefix
    materialNameFormat
    isMaterialModifier
    materialAttributeDimensions {
      ...AdminItemsDrawer_MaterialAttributeDimension
    }
    canBecomeMaterialModifier {
      allowed
      disabledReasons {
        message
      }
    }
    materialLeadTimeConfig {
      ...BoundMaterialLeadTimeConfigFields_MaterialLeadTimeConfig
    }
  }
}
    ${AdminItemsDrawer_MaterialAttributeDimensionFragmentDoc}
${BoundMaterialLeadTimeConfigFields_MaterialLeadTimeConfigFragmentDoc}`;

/**
 * __useAdminItemsDrawerQuery__
 *
 * To run a query within a React component, call `useAdminItemsDrawerQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminItemsDrawerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminItemsDrawerQuery({
 *   variables: {
 *      itemId: // value for 'itemId'
 *   },
 * });
 */
export function useAdminItemsDrawerQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AdminItemsDrawerQuery, AdminItemsDrawerQueryVariables> & ({ variables: AdminItemsDrawerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdminItemsDrawerQuery, AdminItemsDrawerQueryVariables>(AdminItemsDrawerDocument, options);
      }
export function useAdminItemsDrawerLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdminItemsDrawerQuery, AdminItemsDrawerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdminItemsDrawerQuery, AdminItemsDrawerQueryVariables>(AdminItemsDrawerDocument, options);
        }
// @ts-ignore
export function useAdminItemsDrawerSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AdminItemsDrawerQuery, AdminItemsDrawerQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminItemsDrawerQuery, AdminItemsDrawerQueryVariables>;
export function useAdminItemsDrawerSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminItemsDrawerQuery, AdminItemsDrawerQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminItemsDrawerQuery | undefined, AdminItemsDrawerQueryVariables>;
export function useAdminItemsDrawerSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminItemsDrawerQuery, AdminItemsDrawerQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdminItemsDrawerQuery, AdminItemsDrawerQueryVariables>(AdminItemsDrawerDocument, options);
        }
export type AdminItemsDrawerQueryHookResult = ReturnType<typeof useAdminItemsDrawerQuery>;
export type AdminItemsDrawerLazyQueryHookResult = ReturnType<typeof useAdminItemsDrawerLazyQuery>;
export type AdminItemsDrawerSuspenseQueryHookResult = ReturnType<typeof useAdminItemsDrawerSuspenseQuery>;
export type AdminItemsDrawerQueryResult = Apollo.QueryResult<AdminItemsDrawerQuery, AdminItemsDrawerQueryVariables>;
export const SaveItemDimensionsDocument = gql`
    mutation SaveItemDimensions($input: SaveItemsInput!) {
  saveItems(input: $input) {
    id
    materialAttributeDimensions {
      ...AdminItemsDrawer_MaterialAttributeDimension
    }
  }
}
    ${AdminItemsDrawer_MaterialAttributeDimensionFragmentDoc}`;
export type SaveItemDimensionsMutationFn = Apollo.MutationFunction<SaveItemDimensionsMutation, SaveItemDimensionsMutationVariables>;

/**
 * __useSaveItemDimensionsMutation__
 *
 * To run a mutation, you first call `useSaveItemDimensionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveItemDimensionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveItemDimensionsMutation, { data, loading, error }] = useSaveItemDimensionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveItemDimensionsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveItemDimensionsMutation, SaveItemDimensionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveItemDimensionsMutation, SaveItemDimensionsMutationVariables>(SaveItemDimensionsDocument, options);
      }
export type SaveItemDimensionsMutationHookResult = ReturnType<typeof useSaveItemDimensionsMutation>;
export type SaveItemDimensionsMutationResult = Apollo.MutationResult<SaveItemDimensionsMutation>;
export type SaveItemDimensionsMutationOptions = Apollo.BaseMutationOptions<SaveItemDimensionsMutation, SaveItemDimensionsMutationVariables>;